export function getTransactionTypeText(
  transactionType: string,
  internalType?: string,
): string {
  const transactionTypeMap: Record<string, string> = {
    "Personal Payin": "EXTERNAL RECEIVE",
    "Personal Payout": "EXTERNAL SEND",
    "Merchant Payin": "EXTERNAL RECEIVE",
    "Merchant Payout": "EXTERNAL SEND",
    "Internal Payin":
      internalType === "Self" ? "SELF RECEIVE" : "INTERNAL RECEIVE",
    "Internal Payout": internalType === "Self" ? "SELF SEND" : "INTERNAL SEND",
    "Merchant Escrow Payin": "ESCROW TO WALLET",
    "Merchant Escrow Payout": "WALLET TO ESCROW",
    "Merchant Escrow Payout Reversal": "REVERSED FROM ESCROW",
    "Merchant Escrow Payin Reversal": "REVERSED FROM WALLET",
    "Prime Cashier Debit": "WALLET TO ESCROW",
    "Prime Cashier Debit Reversed": "REVERSED FROM ESCROW",
    "Prime Merchant Credit": "ESCROW TO WALLET",
    "Prime Revenue Credit": "ESCROW TO REVENUE",
  };

  return transactionTypeMap[transactionType] ?? transactionType.toUpperCase();
}
